let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6XEq2"), load("8B8z5"), load("aZwOd"), load("F2Q4u")]).then(() => parcelRequire('cI6uD'));